module.exports = __webpack_public_path__ + "static/bg-3b7f568b7c2ecbfc3867281fd421fa07.png";